import { useStaticQuery, graphql } from "gatsby"

export const useHeader = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allMenuLinkContentMenuLinkContent(
          sort: { fields: weight, order: ASC }
          filter: { enabled: { eq: true }, menu_name: { eq: "main" } }
        ) {
          edges {
            node {
              title
              weight
              drupal_parent_menu_item
              drupal_id
              link {
                uri
              }
            }
          }
        }
      }
    `
  )
  return data
}
